import React from 'react';
import { TextField } from '@mui/material';
import SimpleButton from '@common/buttons/SimpleButton';
import MapIcon from '@mui/icons-material/Map';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import MailIcon from '@mui/icons-material/Mail';
import TopBanner from '@common/TopBanner';
import { useApi, useSetFeedback } from 'use-hook-api';
import { useState } from 'react';
import { formApi } from '@api/contactApi';
import { company } from '@components/config/company/Details';
import { sendEmailApi } from '@api/emailApi';
import { LoadingButton } from '@mui/lab';
import Link from 'next/link';

const Contact = () => {
  const [emailFun, { loading: emailLoader }] = useApi({
    errMsg: false,
    successMsg: false,
  });
  const [contactUs, { loading: contactLoader }] = useApi({
    both: true,
    resSuccessMsg: 'We would get back to you ASAP',
  });
  const setFeedback = useSetFeedback();
  const [state, setState] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });
  const [errorState, setErrorState] = useState({
    name: false,
    email: false,
    message: false,
  });
  const onChange = (e) => {
    const { name, value } = e.target;
    setState({ ...state, [name]: value });
    onErrorStateChange(name, false);
  };

  const onErrorStateChange = (name, value) => {
    setErrorState((prevState) => ({ ...prevState, [name]: value }));
  };
  const handleSubmit = () => {
    let error = false;
    if (!state.name || !state.email || !state.message || !state.subject) {
      setFeedback(['Please fill all the highlighted fields', 'error']);
      error = true;
    }
    if (!state.name) {
      onErrorStateChange('name', true);
      error = true;
    }
    if (!state.email) {
      onErrorStateChange('email', true);
      error = true;
    } else if (!state.email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
      setFeedback(['Please enter a valid email', 'error']);
      onErrorStateChange('email', true);
      error = true;
    }
    if (!state.message) {
      onErrorStateChange('message', true);
      error = true;
    }
    if (!state.subject) {
      onErrorStateChange('subject', true);
      error = true;
    }
    if (!error) {
      // let id = process.env.NEXT_PUBLIC_CONTACT_BOARD_ID;
      // contactUs(formApi(state, 'Contact us Form', id), () => {
      //   setState({
      //     name: '',
      //     email: '',
      //     subject: '',
      //     message: '',
      //   });
      // });
      const CompanyEmailData = {
        'support_email': company.company_email,
        'recipient': [company.company_email],
        'message': `Name:${state.name}<br/><br/>Email:${state.email}<br/><br/>Subject:${state.subject}<br/><br/>Message:${state.message}<br/><br/>The above data was submitted on contact us page for ${company.name} website.`,
        'subject': `${company.name} Contact Us `,
        'rich_text': true
      }

      const UserEmailData = {
        'support_email': company.company_email,
        'recipient': [`${state.email}`],
        'message': `Thankyou ${state.name} for contacting us.<br/> We would get back to your query as soon as possible<br/><br/>Regards<br/>${company.name}`,
        'subject': `Thanks for contacting ${company.name}!`,
        'rich_text': true
      }


      emailFun(sendEmailApi(CompanyEmailData), () => {
        emailFun(sendEmailApi(UserEmailData), () => {
          setState({
            name: '',
            email: '',
            subject: '',
            message: '',
          });
          setFeedback(['We would get back to you asap!', 'success'])
        })
      })

    }
  };
  return (
    <>
      <TopBanner title="Contact Us" />
      <div className="container grid grid-cols-4 gap-10 py-20">
        <div className="col-span-4 lg:col-span-3">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-7">
            <div>
              <div className="text-lg">Name</div>
              <TextField
                placeholder="Enter your name"
                error={errorState.name}
                name="name"
                value={state.name}
                onChange={onChange}
                variant="outlined"
                className="w-full mt-2"
              />
            </div>
            <div>
              <div className="text-lg">Email</div>
              <TextField
                placeholder="Enter your name"
                type="email"
                error={errorState.email}
                value={state.email}
                name="email"
                onChange={onChange}
                variant="outlined"
                className="w-full mt-2"
              />
            </div>
            <div className="lg:col-span-2">
              <div className="text-lg">Subject</div>
              <TextField
                placeholder="Your Subject"
                error={errorState.subject}
                name="subject"
                value={state.subject}
                onChange={onChange}
                variant="outlined"
                className="w-full mt-2"
              />
            </div>
            <div className="lg:col-span-2">
              <div className="text-lg">Message</div>
              <TextField
                multiline
                rows={4}
                name="message"
                error={errorState.message}
                value={state.message}
                onChange={onChange}
                placeholder="Your Message"
                variant="outlined"
                className="w-full mt-2"
              />
            </div>
            <div className="lg:col-span-2">
              <LoadingButton

                className="px-7 bg-primary hover:bg-black transition-all text-white"
                loading={emailLoader}
                onClick={handleSubmit}
              >
                Send Message
              </LoadingButton>
            </div>
          </div>
        </div>
        <div className="col-span-4 lg:col-span-1">
          <div className="border border-gray-200 bg-gray-50 text-center px-5 gap-10 h-[450px] flex flex-col justify-center">
            <div>
              <MapIcon className="text-5xl text-primary" />
              <div className="text-lg">
                {company.name} <br />
                {company.address.building}
                <br />
                {company.address.street} <br />
                {company.address.town} <br />
                {company.address.postcode}
              </div>
            </div>
            <div>
              <LocalPhoneIcon className="text-5xl text-primary" />
              <div className="text-lg">
                <a href={`tel:${company.tel_number}`}>{company.tel_number}</a>
              </div>
            </div>
            <div>
              <Link href={`mailto:${company.company_email}`}>
                <a className='hover:underline'>
                  <div>
                    <MailIcon className="text-5xl text-primary" />
                    <div className="text-lg">{company.company_email}</div>
                  </div>
                </a>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
